module.exports = __webpack_public_path__ + "static/K1-a484f81f06ed40882d2fc10bc30f43ff.jpg";